/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Record_E1rmInputs */

const en_us2_workout_live_record_e1rm = /** @type {(inputs: Workout_Live_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best estimated 1RM`)
};

const pt_br2_workout_live_record_e1rm = /** @type {(inputs: Workout_Live_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior 1RM estimado`)
};

const es_419_workout_live_record_e1rm = /** @type {(inputs: Workout_Live_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayor 1RM estimado`)
};

const pt_pt2_workout_live_record_e1rm = /** @type {(inputs: Workout_Live_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior 1RM estimado`)
};

const fr_fr2_workout_live_record_e1rm = /** @type {(inputs: Workout_Live_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleur 1RM estimé`)
};

const de_de2_workout_live_record_e1rm = /** @type {(inputs: Workout_Live_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bester geschätzter 1RM`)
};

const it_it2_workout_live_record_e1rm = /** @type {(inputs: Workout_Live_Record_E1rmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miglior 1RM stimato`)
};

/**
* | output |
* | --- |
* | "Best estimated 1RM" |
*
* @param {Workout_Live_Record_E1rmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_record_e1rm = /** @type {((inputs?: Workout_Live_Record_E1rmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Record_E1rmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_record_e1rm(inputs)
	if (locale === "es-419") return es_419_workout_live_record_e1rm(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_record_e1rm(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_record_e1rm(inputs)
	if (locale === "de-DE") return de_de2_workout_live_record_e1rm(inputs)
	if (locale === "it-IT") return it_it2_workout_live_record_e1rm(inputs)
	return en_us2_workout_live_record_e1rm(inputs)
});
export { workout_live_record_e1rm as "workout-live.record_e1rm" }